// @ts-ignore - Supabase types issue in development
import { createClient } from '@supabase/supabase-js';

// Check if required environment variables are present
// In React, env vars are available at build time and injected into process.env
declare const process: {
  env: {
    REACT_APP_SUPABASE_URL?: string;
    REACT_APP_SUPABASE_ANON_KEY?: string;
  };
};

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn('❌ Missing Supabase configuration! This feature set will be disabled.');
}

// If config present, create real client; otherwise return a harmless stub to avoid runtime errors
function createStubResponse() {
  return Promise.resolve({ data: null, error: new Error('Supabase not configured') });
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl as string, supabaseAnonKey as string, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : ({
      from: () => {
        const builder: any = {
          select: () => builder,
          insert: () => builder,
          update: () => builder,
          delete: () => builder,
          order: () => builder,
          single: () => createStubResponse(),
          maybeSingle: () => createStubResponse(),
          then: (res: any) => createStubResponse().then(res),
        };
        return builder;
      },
      auth: {
        signIn: () => createStubResponse(),
        signOut: () => createStubResponse(),
        getSession: () => createStubResponse(),
        onAuthStateChange: (cb: any) => ({ data: { subscription: { unsubscribe: () => {} } }, error: null }),
      },
    } as any);